import { useApiClient, enumValue } from '@siclop/kstone-vue'
import type { LeaveSettings } from '../models'
import { RttMode } from '../enums/RttMode'

/** L'API sérialise les énumérations en texte (« None ») : le formulaire travaille avec leurs valeurs numériques. */
function normalize(settings: LeaveSettings): LeaveSettings {
  const mode = enumValue(RttMode, settings.rttMode)
  return { ...settings, rttMode: typeof mode === 'number' ? mode : RttMode.None }
}

/**
 * Paramètres de congés de l'entreprise (droit annuel, ancienneté, fractionnement, RTT) : lecture
 * VIEW_COMPANY_SETTINGS, écriture EDIT_COMPANY_SETTINGS. L'enregistrement recalcule les soldes côté serveur.
 */
export class LeaveSettingsService {
  private static readonly url = '/leave-settings'

  /** Paramètres de l'organisation (valeurs par défaut, `id = 0`, s'ils n'ont jamais été enregistrés). */
  static async get(organizationId: number): Promise<LeaveSettings> {
    return normalize(await useApiClient().get<LeaveSettings>(`${this.url}?organizationId=${organizationId}`))
  }

  /** Enregistre les paramètres ; lève une erreur (message de l'API) s'ils sont invalides. */
  static async save(organizationId: number, settings: LeaveSettings): Promise<LeaveSettings> {
    return normalize(await useApiClient().putRaw<LeaveSettings, LeaveSettings>(
      `${this.url}?organizationId=${organizationId}`, { ...settings, organizationId }))
  }
}
